const StaffCoordinator247Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.0907 18.9141C22.7514 18.9141 15.1804 25.0449 15.1804 32.6077C15.1804 37.3358 18.1395 41.5042 22.6398 43.9648C22.9103 46.5771 19.8216 48.7803 19.8216 48.7803C24.9222 48.7803 27.9314 45.8837 27.9314 45.8837L27.9304 45.8833C29.2614 46.156 30.655 46.3014 32.0907 46.3014C41.43 46.3014 49.001 40.1705 49.001 32.6077C49.001 25.0449 41.43 18.9141 32.0907 18.9141Z"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4627 35.7622V34.9992L24.6692 32.8447C24.9437 32.5789 25.1518 32.357 25.2935 32.1793C25.435 32.0016 25.5326 31.8427 25.5861 31.7025C25.6395 31.5624 25.6662 31.4157 25.6662 31.2625V31.2538C25.6662 31.066 25.6221 30.9005 25.534 30.7575C25.4459 30.6144 25.3244 30.5017 25.1699 30.4193C25.0153 30.337 24.8383 30.2958 24.6388 30.2958C24.4077 30.2958 24.2032 30.3428 24.0255 30.4367C23.8477 30.5306 23.7075 30.6578 23.605 30.8181C23.5023 30.9785 23.4496 31.1599 23.4468 31.3622V31.3925H22.3977V31.3622C22.3977 30.9807 22.4959 30.6426 22.6924 30.3478C22.889 30.053 23.1556 29.8211 23.4923 29.652C23.8289 29.483 24.2082 29.3984 24.6302 29.3984C25.0463 29.3984 25.4148 29.4758 25.7356 29.6304C26.0564 29.785 26.3071 29.9974 26.4877 30.2676C26.6683 30.5379 26.7587 30.8449 26.7587 31.1888V31.1975C26.7587 31.4431 26.7146 31.6729 26.6264 31.8867C26.5382 32.1006 26.3894 32.3332 26.1799 32.5846C25.9704 32.8361 25.6807 33.138 25.3108 33.4906L23.5335 35.1856L23.9366 34.4487V35.1856L23.5378 34.8474H26.8541V35.7622H22.4627Z"
        fill="#FFA473"
      />
      <path
        d="M30.5213 35.7632V34.558H27.4001V33.6086C27.5735 33.337 27.7469 33.064 27.9203 32.7894C28.0937 32.5148 28.2671 32.241 28.4405 31.9679C28.6139 31.6948 28.7866 31.4217 28.9586 31.1486C29.1305 30.8755 29.3032 30.6024 29.4766 30.3293C29.65 30.0562 29.8234 29.7824 29.9968 29.5078H31.5877V33.6477H32.433V34.558H31.5877V35.7632H30.5213ZM28.4059 33.6694H30.5387V30.3531H30.5127C30.371 30.5728 30.2301 30.7917 30.09 31.0099C29.9498 31.2281 29.8097 31.447 29.6695 31.6666C29.5293 31.8863 29.3884 32.1059 29.2468 32.3256C29.1052 32.5452 28.9643 32.7641 28.8242 32.9823C28.684 33.2005 28.5446 33.4194 28.4059 33.639V33.6694Z"
        fill="#FFA473"
      />
      <path
        d="M36.2219 28.8672L34.5833 36.6397H33.6079L35.2466 28.8672H36.2219Z"
        fill="#FFA473"
      />
      <path
        d="M37.9384 35.7632L40.6824 30.4442V30.4225H37.4312V29.5078H41.7835V30.4398L39.1088 35.7632H37.9384Z"
        fill="#FFA473"
      />
      <path
        d="M60.7795 35.9717V38.8496V33.0938V35.9717Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.22144 35.7842V38.6621V32.9062V35.7842Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.9314 61.3312L50.5365 60.7577C49.3437 60.2672 48.7742 58.9027 49.2647 57.7098L56.5511 39.987C57.0415 38.7941 58.406 38.2247 59.5989 38.7151L60.9938 39.2886C62.7443 40.0083 63.2899 41.918 62.8603 43.7613C61.4864 49.6558 59.4668 55.1086 56.4042 59.4647C55.3156 61.013 53.6819 62.0508 51.9314 61.3312Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M54.2121 39.7119C54.5005 39.8321 54.637 40.1638 54.5168 40.4522L48.0387 55.9955C47.9185 56.2839 47.5868 56.4204 47.2984 56.3002C46.6349 56.0237 46.3208 55.2606 46.5973 54.5972L52.509 40.413C52.7855 39.7496 53.5486 39.4354 54.2121 39.7119Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0624 60.7687L13.4565 60.1952C14.6487 59.7048 15.2179 58.3402 14.7277 57.1473L7.44531 39.4245C6.95515 38.2316 5.59132 37.6622 4.39911 38.1526L3.00498 38.7261C1.25541 39.4458 0.710111 41.3555 1.13952 43.1988C2.51268 49.0933 4.53116 54.5461 7.59213 58.9022C8.68012 60.4505 10.3128 61.4884 12.0624 60.7687Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.693 55.7357C17.3565 55.459 17.6702 54.6965 17.3937 54.0327L11.4852 39.8485C11.2087 39.1846 10.4466 38.8707 9.78306 39.1474C9.49466 39.2677 9.3583 39.5991 9.4785 39.8877L15.9531 55.431C16.0733 55.7196 16.4046 55.856 16.693 55.7357Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M4.33228 32.7855C4.33228 17.5043 16.7194 5.11719 32.0005 5.11719C47.2817 5.11719 59.6688 17.5043 59.6688 32.7855"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.21167 32.7888C2.21167 16.3373 15.549 3 32.0005 3C48.452 3 61.7893 16.3373 61.7893 32.7888"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33223 32.7891H2.21167"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.7895 32.7891H59.6689"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StaffCoordinator247Icon;
